var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 56,
    viewBox: "0 0 51 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5100_74170)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.837,
    height: 56,
    transform: "translate(0.242188)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3902 18.6559C31.3921 21.4258 30.6627 24.134 29.2944 26.438C27.9261 28.7419 25.9803 30.538 23.7033 31.599C21.4263 32.6599 18.9204 32.9381 16.5026 32.3983C14.0849 31.8584 11.8639 30.5248 10.1209 28.5662C8.37787 26.6076 7.19105 24.1121 6.71062 21.3953C6.23018 18.6786 6.47773 15.8628 7.42193 13.3042C8.36614 10.7456 9.96457 8.55917 12.015 7.02166C14.0653 5.48415 16.4755 4.66461 18.9406 4.66675C22.2416 4.66962 25.4067 6.1444 27.7409 8.76725C30.0751 11.3901 31.3876 14.9466 31.3902 18.6559Z",
    fill: "#A1D23F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0265 12.1707L35.3838 15.0957L19.0068 44.6726",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7536 15.3367C20.358 14.2136 21.2525 13.3239 22.318 12.7862C23.3835 12.2484 24.5695 12.0881 25.7181 12.3265C30.2799 13.6612 35.3977 15.1663 35.3977 15.1663L27.8157 28.8685L14.4463 25.0206L19.7536 15.3367Z",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.433 24.9497C13.9675 26.2183 13.0944 27.2437 11.9871 27.8224C10.8798 28.4011 9.61929 28.4907 8.45592 28.0735L0.242188 25.688L7.52083 19.6676L7.8241 12L19.6519 15.5356",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5100_74170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.837,
    height: 56,
    fill: "white",
    transform: "translate(0.242188)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFlag);
export default __webpack_public_path__ + "static/media/GreenFlag.6128d4dfe26745fe0d4dbcbc35b05c4f.svg";
export { ForwardRef as ReactComponent };